import { createFileRoute } from "@tanstack/react-router";
import { SignInPage, type SignInSearch } from "../components/auth/sign-in-page";
import { searchString } from "../lib/search";

export const Route = createFileRoute("/signin")({
  // Unknown params (the signed AI-connector query) are left in the URL untouched;
  // the Better Auth plugin reads them from window.location.
  validateSearch: (search: Record<string, unknown>): SignInSearch => {
    const out: SignInSearch = {};
    const next = searchString(search.next);
    const app = searchString(search.app);
    const error = searchString(search.error);
    const step = searchString(search.step);
    const email = searchString(search.email);
    if (next !== undefined) out.next = next;
    if (app !== undefined) out.app = app;
    if (error !== undefined) out.error = error;
    if (step !== undefined) out.step = step;
    if (email !== undefined) out.email = email;
    return out;
  },
  component: SignInRoute,
});

function SignInRoute() {
  const search = Route.useSearch();
  return <SignInPage search={search} />;
}
